export default __webpack_public_path__ + "static/media/windchimes.455b775e.svg";